import _slicedToArray from "/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { standard } from '@creditas-ui/themes';
import { mediaHelper } from './media-helper';
var numericBreakpoints = standard.breakpoints.map(function (breakpoint) {
  return parseInt(breakpoint.replace('px', ''), 10);
});

var _numericBreakpoints = _slicedToArray(numericBreakpoints, 13),
    breakpointsXs = _numericBreakpoints[0],
    breakpointsSm = _numericBreakpoints[1],
    breakpointsMd = _numericBreakpoints[2],
    breakpointsLg = _numericBreakpoints[3],
    breakpointsXl = _numericBreakpoints[4],
    breakpoints2Xl = _numericBreakpoints[5],
    breakpoints3Xl = _numericBreakpoints[6],
    breakpoints4Xl = _numericBreakpoints[7],
    breakpoints5Xl = _numericBreakpoints[8],
    breakpoints6Xl = _numericBreakpoints[9],
    breakpoints7Xl = _numericBreakpoints[10],
    breakpoints8Xl = _numericBreakpoints[11],
    breakpoints9Xl = _numericBreakpoints[12];

var sizes = {
  xs: breakpointsXs,
  sm: breakpointsSm,
  md: breakpointsMd,
  lg: breakpointsLg,
  xl: breakpointsXl,
  '2xl': breakpoints2Xl,
  '3xl': breakpoints3Xl,
  '4xl': breakpoints4Xl,
  '5xl': breakpoints5Xl,
  '6xl': breakpoints6Xl,
  '7xl': breakpoints7Xl,
  '8xl': breakpoints8Xl,
  '9xl': breakpoints9Xl
};
var media = mediaHelper(sizes);
export { media };